import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResetpasswordService {

  constructor(private http: HttpClient) { }

  SendPasswordResetEmailAsync(memberid: number) {
    return this.http.get(environment.apiUrl + 'AnonymousPasswordReset/SendPasswordResetEmailAsync/' + memberid);
  }

  ResetPasswordAsync(token: string, username: string, password: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    const resetdata = {
      userName: username,
      passwords: {
        password: password,
        passwordConfirmation: password,
      },
      passwordResetToken: token
    };

    return this.http.post<any>(environment.apiUrl + 'AnonymousPasswordReset/ResetPasswordAsync', JSON.stringify(resetdata), httpOptions);
  }
}
